export default {
  data() {
    return {
      page: 0,
      checked: false,
    }
  },
  methods: {
    incrementPage() {
      this.page++;
    },
    toggleCheckbox() {
      this.checked = !this.checked;
      this.$emit('complete')
    }
  },
  render(h) {
    const page1 = (
      <div class="shadow-md bg-white rounded mx-3 lg:mx-6 bg-cover bg-top" style="background-image: url(/img/changemanagement/section-3-welcome.png)">
        <div class="h-full flex flex-col items-center justify-center text-center text-white py-6 lg:py-24 leading-none">
          <img src="/img/changemanagement/WHO%20Logo%20Wht_Horz@2x.png" alt="" class="w-32 lg:w-56 mb-5"/>
          <h2 class="text-xl lg:text-5xl">
            Welcome to
          </h2>
          <h1 class="text-2xl lg:text-6xl">
            <strong>Change Management</strong><br/>
            In Your Work
          </h1>
          <button type="button" onClick={this.incrementPage} class="mt-5 lg:mt-16 rounded-full bg-brand-orange-700 hover:bg-brand-orange-600 text-white uppercase py-3 lg:py-2 px-12 lg:px-16 text-lg lg:text-2xl focus:outline-none transition-colors duration-100">
            Begin
          </button>
        </div>
      </div>
    );
    const checkbox = this.checked
      ? <img src="/img/changemanagement/checkbox-checked.svg" alt="" class="w-6 inline-flex -mt-2 mr-3"/>
      : <img src="/img/changemanagement/checkbox-outline.svg" alt="" class="w-6 inline-flex -mt-2 mr-3"/>;
    const page2 = (
      <div class="shadow-md mx-3 lg:mx-6 bg-white rounded">
        <div class="p-6 py-10 lg:py-16 lg:px-24">

          <p class="lg:text-2xl">
            How will you apply what you have just learned? Reflect on a change you need to make in your own work. First,
            download the documents below. Next, answer the questions in the Workbook. You may use the Bonus Guide as a
            reference.
          </p>

          <p class="text-2xl font-bold text-center my-6">
            Download the Resources:
          </p>

          <div class="lg:w-6/12 mx-auto flex items-center">
            <div class="w-1/2 flex flex-col items-center">
              <img src="/img/changemanagement/icn-pdf.svg" alt="PDF" class="w-12 mb-6"/>
              <a href="/resources/changemanagement/Reflection_Questions.pdf" target="_blank"
                class="mb-3 lg:mb-0 mr-3 bg-brand-blue-500 rounded-full p-2 px-4 lg:px-10 uppercase text-white text-xs lg:text-sm focus:outline-none focus:shadow-outline">
                WORKBOOK
              </a>
            </div>
            <div class="w-1/2 flex flex-col items-center">
              <img src="/img/changemanagement/icn-pdf.svg" alt="PDF" class="w-12 mb-6"/>
              <a href="/resources/changemanagement/Change_Management_Resource_Guide.pdf" target="_blank"
                class="mb-3 lg:mb-0 mr-3 bg-brand-blue-500 rounded-full p-2 px-4 lg:px-10 uppercase text-white text-xs lg:text-sm focus:outline-none focus:shadow-outline">
                BONUS GUIDE
              </a>
            </div>
          </div>

          <p class="lg:text-2xl text-center mt-12 cursor-pointer" onClick={this.toggleCheckbox}>
            {checkbox}
            Click here after you have downloaded the documents.
          </p>
        </div>
      </div>
    );
    const pages = [page1, page2];
    const modal = this.checked && (
      <div>
        <div class="absolute top-0 left-0 w-full h-full bg-gray-900 opacity-50"></div>
        <div class="absolute w-full h-full top-0 left-0 overflow-y-auto">
          <div class="-translate-y-1/2 -translate-x-1/2 transform w-10/12 lg:w-full absolute" style="top: 50%; left: 50%;">
            <div class="bg-white container md:max-w-5xl mx-auto rounded shadow-lg relative z-50">
              <div class="w-11/12 lg:w-9/12 mx-auto text-center px-3 py-10 flex flex-col items-center">

                <p class="text-2xl lg:text-3xl font-bold leading-snug">
                  Congratulations!
                </p>

                <img src="/img/changemanagement/img-trophy.svg" alt="" class="w-48 mt-4"/>

                <p class="text-lg lg:text-xl">
                  You have completed this course.
                </p>

                <button type="button" onClick={this.toggleCheckbox}
                        class="mt-8 mx-auto rounded-full bg-brand-orange-700 text-white uppercase py-1 px-10 lg:text-xl hover:bg-orange-700 focus:outline-none transition-colors duration-100">
                  CLOSE WINDOW
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    return (
      <div class="py-5 relative">
        {pages[this.page]}
        {modal}
      </div>
    );
  }
}
